import { Provider } from "@angular/core";
import { TranslateResolver, UserLocaleResolver, ProtectedUrlResolver } from "@ubisolutions/base";
import { CURRENT_USER_QUERY, IconResolver, ModelNameKeyResolver } from "@ubisolutions/core";
import { MeGraphql } from "@shared/core/services/user-services.graphql";
import { CtTranslateResolver } from "./ct-translate-resolver";
import { CtIconResolver } from "./ct-icon-resolver";
import { CtUserLocaleResolver } from "./ct-user-locale-resolver";
import { CtProtectedUrlResolver } from "./ct-protected-url-resolver";
import { CtModelNameKeyResolver } from "./ct-model-name-key-resolver";

export const ubisolutionsProviders: Provider[] = [
    { provide: TranslateResolver, useClass: CtTranslateResolver },
    { provide: IconResolver, useClass: CtIconResolver },
    { provide: UserLocaleResolver, useClass: CtUserLocaleResolver },
    { provide: ProtectedUrlResolver, useClass: CtProtectedUrlResolver },
    { provide: ModelNameKeyResolver, useClass: CtModelNameKeyResolver },
    { provide: CURRENT_USER_QUERY, useValue: MeGraphql },
];
